// if no changes detected after comparison
let noFSWChangesDetected = true;
// first selector elem
const firstFSWSelector = document.getElementById('fswatcher__first_date');
// second selector elem
const secondFSWSelector = document.getElementById('fswatcher__second_date');
// FSW table body
const fsWatcherTableBody = document.getElementById('spbc-table-fs_watcher-comparison');
// available types of events
const availableFSWDataSetNames = ['added', 'changed', 'deleted'];

if ( document.readyState !== 'loading' ) {
    FSWOnload(); // eslint-disable-line new-cap
} else {
    document.addEventListener('DOMContentLoaded', FSWOnload);
}

// listeners
document.getElementById('fswatcher__compare').addEventListener('click', FSWCompare);
document.getElementById('fswatcher__create_snapshot').addEventListener('click', FSWCreate);
firstFSWSelector.addEventListener('change', filterFSWSecondSelector);
secondFSWSelector.addEventListener('change', filterFSWFirstSelector);

// eslint-disable-next-line require-jsdoc
function FSWOnload() {
    document.querySelector('#fswatcher__first_date').selectedIndex = 0;
    let secondDate = document.querySelector('#fswatcher__second_date');
    secondDate.selectedIndex = secondDate.options.length - 1;
    FSWCompare(new Event({})); // eslint-disable-line new-cap
}

/**
 * Main handler function. Run this on the button click.
 * @param {Event} e click event.
 * @return {void|false}
 */
function FSWCompare(e) {
    e.preventDefault();

    if (e.currentTarget !== null) {
        document.querySelector('#fsw_preloader_compare').style.display = 'inline';
    }

    if ( typeof document.getElementById('fswatcher__first_date') === 'undefined' ||
        typeof document.getElementById('fswatcher__second_date') === 'undefined' ) {
        return false;
    }

    let firstDate = document.getElementById('fswatcher__first_date').value;
    let secondDate = document.getElementById('fswatcher__second_date').value;

    let data = {
        action: 'spbct_fswatcher_compare',
        fswatcher__first_date: firstDate,
        fswatcher__second_date: secondDate,
    };

    let params = {
        callback: function(response) {
            let responseDataObj = {};
            noFSWChangesDetected = true;
            if (typeof response === 'object') {
                responseDataObj = response;
            } else if (typeof response === 'string') {
                responseDataObj = FSWDecodeJSON(response); // eslint-disable-line new-cap
                if (responseDataObj.hasOwnProperty('error')) {
                    alert(fswatcherTranslations['fs_err_parse_json']);
                    console.log('File System watcher JSON parse error: ' + responseDataObj.error);
                    return;
                }
            }

            const validateResult = validateFSWResponse(responseDataObj);
            if (true === validateResult) {
                renderFSWatcherTableContent(responseDataObj);
                if (noFSWChangesDetected) {
                    renderFSWTableRow( '', 'no_changes', '');
                }
            } else {
                alert(validateResult + ' ' + fswatcherTranslations['fs_err_valid_result'] + ' support@cleantalk.org');
                console.log('File System watcher response validating error: ' + validateResult);
            }
            resetFSWSelectors();
            toggleFSWSelectorsInfo(true);
            document.querySelector('#fsw_preloader_compare').style.display = 'none';
        },
    };

    spbcSendAJAXRequest(data, params);
}

/**
 * Create snapshot handler.
 * @param {Event} e
 * @constructor
 */
function FSWCreate(e) {
    e.preventDefault();

    if (e.currentTarget !== null) {
        document.querySelector('#fsw_preloader_create').style.display = 'inline';
    }

    let data = {
        action: 'spbct_fswatcher_create_snapshot',
    };

    let params = {
        callback: function(response) {
            if (typeof response === 'string') {
                FSWDecodeJSON(response); // eslint-disable-line new-cap
            }
            document.querySelector('#fsw_preloader_create').style.display = 'none';
        },
        button: e.target,
        timeout: 30000,
    };

    spbcSendAJAXRequest(data, params);
}

/**
 * View file content in modal window.
 * @param {HTMLElement} el
 * @constructor
 */
function FSWViewFile(el) { // eslint-disable-line no-unused-vars
    let wpWrap = jQuery('#wpwrap');
    let dialogWindow = jQuery('#spbc_dialog');

    dialogWindow.dialog({
        modal: true,
        title: fswatcherTranslations['fs_modal'] + ' ' + el.dataset.path,
        position: {my: 'center top', at: 'center top+100px', of: window},
        width: +(wpWrap.width() / 100 * 90),
        show: {effect: 'blind', duration: 500},
        draggable: false,
        resizable: false,
        closeText: 'X',
        classes: {'ui-dialog': 'spbc---top'},
        open: function(event, ui) {
            event.target.style.overflow = 'auto';
            jQuery('#spbc_dialog').height((document.documentElement.clientHeight) / 100 * 25);
        },
        beforeClose: function(event, ui) {
            document.body.style.overflow = 'auto';
            jQuery('#spbc_dialog').empty();
        },
    });

    dialogWindow.append('<img id="spbc_file_view_preloader" alt="Wait for downloading" ' +
        'class="spbc_preloader" ' +
        'src="../../wp-content/plugins/security-malware-firewall/images/preloader2.gif" ' +
        'style="' +
        'display: block; ' +
        'position: absolute; ' +
        '">');

    let spinner = jQuery('#spbc_file_view_preloader');
    let sizeMultiplier = (wpWrap.width() * 0.0004);

    spinner.height(128 * sizeMultiplier);
    spinner.width(128 * sizeMultiplier);
    spinner.css({left: dialogWindow.width()/2 - (128 * sizeMultiplier / 2)});
    spinner.css({top: dialogWindow.height()/2 - (128 * sizeMultiplier / 2)});

    const firstSelectorId = jQuery('#fswatcher__first_date').val();
    const secondSelectorId = jQuery('#fswatcher__second_date').val();

    let data = {
        action: 'spbct_fswatcher_view_file',
        fswatcher_file_path: el.dataset.path,
        fswatcher__first_date: firstSelectorId,
        fswatcher__second_date: secondSelectorId,
    };

    let callback = function(response) {
        let content = '';
        if (typeof response.error !== 'undefined') {
            content = response.error;
        } else if (typeof response.data !== 'undefined') {
            content = response.data;
        } else {
            content = 'Unknown error on reading file. Data is empty.';
        }
        content = content.split('\n');
        let dialogWindow = jQuery('#spbc_dialog');
        dialogWindow.empty();
        jQuery('#spbc_file_view_preloader').css({display: 'none'});
        let rowTemplate = '<div class="spbc_view_file_row_wrapper">' +
                '<span class="spbc_view_file_row_num">%s</span>' +
                '<p class="spbc_view_file_row">%s</p>' +
                '<br /><' +
            '/div>';

        content.forEach((line, index) => {
            dialogWindow.append(rowTemplate.printf(index + 1, line));
        });

        let contentHeight = Object.keys(content).length * 19 < 76 ? 76 : Object.keys(content).length * 19;
        let visibleHeight = (document.documentElement.clientHeight) / 100 * 75;
        let overflow = contentHeight < visibleHeight ? 'hidden' : 'scroll';
        let height = overflow === 'scroll' ? visibleHeight : contentHeight;

        dialogWindow.css({
            height: height,
            overflow: overflow,
        });
    };

    spbcSendAJAXRequest(data, {callback: callback});
}

/**
 * Try to decode JSON string from site response.
 * @param {string} response
 * @return {obj} Json parsed obj or error obj.
 */
function FSWDecodeJSON(response) {
    try {
        return JSON.parse(response);
    } catch (e) {
        return {'error': e};
    }
}

/**
 * Run rendering comparison table in dependence of response object
 * @param {{}} responseDataObj
 */
function renderFSWatcherTableContent(responseDataObj) {
    fsWatcherTableBody.innerHTML = '';
    for (const dataSetName of availableFSWDataSetNames) {
        if (handleFSWDataObject(responseDataObj, dataSetName)) {
            noFSWChangesDetected = false;
        }
    }
}

/**
 * Validate response object from site.
 * @param {obj} responseDataObj
 * @return {*|boolean}
 */
function validateFSWResponse(responseDataObj) {
    if (
        !responseDataObj ||
        typeof responseDataObj !== 'object'
    ) {
        return fswatcherTranslations['fs_err_resp_obj'];
    }

    if (typeof responseDataObj.error !== 'undefined') {
        return responseDataObj.error;
    }

    for (const dataSetName of availableFSWDataSetNames) {
        if (
            !responseDataObj.hasOwnProperty(dataSetName)
        ) {
            return fswatcherTranslations['fs_err_property'];
        }
    }

    return true;
}

/**
 * @param {object} responseDataObj
 * @param {string|number} eventType
 * @return {boolean}
 */
function handleFSWDataObject(responseDataObj, eventType) {
    const eventsArray = responseDataObj[eventType];
    if (eventsArray.length > 0) {
        for (let i = 0; i < eventsArray.length; i++) {
            const row = convertFSWEventToRow(eventsArray[i], eventType);
            renderFSWTableRow(row.path, row.event_type, row.date);
        }
    } else {
        return false;
    }
    return true;
}

/**
 * Convert a row of site response to the formatted data.
 * @param {object} event contains the date and the file path
 * @param {string} eventType contains event type
 * @return {{path: string, event_type: string, date: string}} row of the table
 */
function convertFSWEventToRow(event, eventType) {
    let row = {
        'path': 'unknown',
        'event_type': eventType.toUpperCase(),
        'date': 'unknown',
    };

    if (event.length === 2) {
        if (typeof event[0] === 'string') {
            row.path = event[0];
            if (row.event_type !== 'DELETED') {
                row.path += '<br><span data-path="' + row.path + '" onclick="FSWViewFile(this);" style="cursor: pointer; color: blue;">View</span>'; // eslint-disable-line max-len
            }
        }
        if (typeof event[1] === 'string') {
            let d = new Date(Number(event[1]) * 1000);
            shortMonthName = new Intl.DateTimeFormat('en-US', {month: 'short'}).format;
            let minutes = String(d.getMinutes()).padStart(2, '0');
            let seconds = String(d.getSeconds()).padStart(2, '0');
            row.date = shortMonthName(d) +
                ' ' +
                d.getDate() +
                ' ' +
                d.getFullYear() +
                ' ' +
                d.getHours() +
                ':' +
                minutes +
                ':' +
                seconds;
        }
    }

    return row;
}

/**
 * Render the row of FSW table.
 * @param {string} path the file path
 * @param {string} eventType the event type
 * @param {string} date the date of event
 */
function renderFSWTableRow(path, eventType, date) {
    if (eventType === 'no_changes') {
        let tr = document.createElement('tr');
        let td = document.createElement('td');
        td.setAttribute('name', 'fswatcher-event-no-changes');
        td.setAttribute('colspan', '3');
        td.innerText = fswatcherTranslations['fs_no_changes'];
        tr.appendChild(td);
        fsWatcherTableBody.appendChild(tr);
        return;
    }

    let tr = document.createElement('tr');

    let tdPath = document.createElement('td');
    tdPath.setAttribute('name', 'fswatcher-event-path');
    tdPath.setAttribute('data-before', 'Path');
    tdPath.innerHTML = path;
    tr.appendChild(tdPath);

    let tdType = document.createElement('td');
    tdType.setAttribute('name', 'fswatcher-event-type');
    tdType.setAttribute('data-before', 'Event');
    tdType.innerText = eventType;
    tr.appendChild(tdType);

    let tdDate = document.createElement('td');
    tdDate.setAttribute('name', 'fswatcher-event-date');
    tdDate.setAttribute('data-before', 'Changed on date');
    tdDate.innerText = date;
    tr.appendChild(tdDate);

    fsWatcherTableBody.appendChild(tr);
}

/**
 * Filter options for the first selector and disable it to keep it from changes.
 */
function filterFSWSecondSelector() {
    toggleFSWSelectorsInfo(false);
}

/**
 * Filter options for the second selector and disable it to keep it from changes.
 */
function filterFSWFirstSelector() {
    toggleFSWSelectorsInfo(false);
}

/**
 * Reset selectors to its initial statements.
 */
function resetFSWSelectors() {
    for (let i = 0; i < firstFSWSelector.options.length; i++) {
        firstFSWSelector.options[i].style.display = 'inherit';
    }
    for (let i = 0; i < secondFSWSelector.options.length; i++) {
        secondFSWSelector.options[i].style.display = 'inherit';
    }
    secondFSWSelector.removeAttribute('disabled');
    firstFSWSelector.removeAttribute('disabled');
}

/**
 * Toggle info string.
 * @param {boolean} enable Set logs names if true, disable content if false.
 */
function toggleFSWSelectorsInfo(enable) {
    let infoTag = document.getElementById('spbc--fs-watcher-table-handling-selects-info');
    if (
        enable &&
        typeof firstFSWSelector.options[firstFSWSelector.selectedIndex] !== 'undefined' &&
        typeof secondFSWSelector.options[secondFSWSelector.selectedIndex] !== 'undefined'
    ) {
        const changesCountOnTRS = document.querySelectorAll('#spbc-table-fs_watcher-comparison > tr').length;
        const hasNoChangesTD = document.getElementsByName('fswatcher-event-no-changes').length;
        const changesCount = hasNoChangesTD > 0 ? 0 : changesCountOnTRS;

        infoTag.style.display = 'inherit';
        infoTag.innerHTML= fswatcherTranslations['fs_comparing'] +
            ' <b>' + firstFSWSelector.options[firstFSWSelector.selectedIndex].text + '</b> ' +
            fswatcherTranslations['fs_with'] +
            ' <b>' + secondFSWSelector.options[secondFSWSelector.selectedIndex].text + '</b> ' +
            fswatcherTranslations['fs_total'] +
            ' <b>' + changesCount + '</b>';
    } else {
        infoTag.innerText = '';
        infoTag.style.display = 'none';
    }
}


